export class StockRequestModel {
    branchCode: Array<string> = new Array<string>();
    productCode: Array<string> = new Array<string>();

    constructor(){
        
    }
}